import(/* webpackMode: "eager" */ "/home/runner/work/odds-gate/odds-gate/nextjs/src/app/loading.tsx");
